module.exports = __webpack_public_path__ + "img/f-1.e50d11f3.jpg";